import { Checkout, CheckoutStep, track } from '@dfds-frontend/tracking'

import { TrackingData } from './_actions/getTrackingData'
import { getProducts } from './_ecommerce/products'

export const trackCheckout = (step: CheckoutStep, data: TrackingData): void => {
  const products = getProducts(data)
  products &&
    track<Checkout>({
      ecommerce: {
        checkout: {
          actionField: { step },
          products: products,
        },
      },
      event: 'checkout',
    })
}

export const CheckoutSteps: Record<string, CheckoutStep> = {
  checkout: 1,
  payment: 2,
}
